module.exports = __webpack_public_path__ + "static/4.0ae88c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msc/4.png
// module id = 889
// module chunks = 144974278801183 275805287939862